import { Link } from "wouter";
import type { BlogPostSummary } from "@/api/blog";
import { formatUkDate } from "@/utils/date";
import TagChip from "./TagChip";

export default function PostCard({ post }: { post: BlogPostSummary }) {
  return (
    <article className="home-card rounded-[28px] overflow-hidden flex flex-col transition-shadow hover:shadow-[0_20px_50px_rgba(17,17,17,0.08)]">
      <Link href={`/blog/${post.slug}`} className="block aspect-[16/9] bg-[rgba(17,17,17,0.04)]">
        {post.hero_image_url ? (
          <img src={post.hero_image_url} alt="" className="h-full w-full object-cover" />
        ) : null}
      </Link>
      <div className="p-6 flex-1 flex flex-col">
        {post.tags.length > 0 ? (
          <div className="flex flex-wrap gap-2 mb-4">
            {post.tags.slice(0, 3).map((tag) => (
              <TagChip key={tag} tag={tag} />
            ))}
          </div>
        ) : null}
        <h2 className="font-display text-[1.2rem] font-semibold tracking-tight leading-snug mb-3 text-brand-navy">
          <Link href={`/blog/${post.slug}`} className="hover:text-[#0E9E77] transition-colors">
            {post.title}
          </Link>
        </h2>
        {post.excerpt ? (
          <p className="text-sm text-[#666666] leading-relaxed mb-5 line-clamp-3">{post.excerpt}</p>
        ) : null}
        <p className="mt-auto text-xs text-[#666666] tracking-wide">
          {post.author_name}
          {post.published_at ? ` · ${formatUkDate(post.published_at)}` : ""}
          {post.reading_time_minutes ? ` · ${post.reading_time_minutes} min read` : ""}
        </p>
      </div>
    </article>
  );
}
